/** Default application SQL migrations directory (project-relative). */
export const DEFAULT_MIGRATIONS_DIRECTORY = "athena/migrations";

/** Materialized, read-only view of package-owned Embedded Auth generations. */
export const DEFAULT_MANAGED_AUTH_MIGRATIONS_DIRECTORY =
	"athena/managed/auth/migrations";
